import { Component, EventEmitter, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';
import { MatTableDataSource } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import {
  RepoPosition

} from '../../models/repo-business/repo-business.model';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
import { RepoBusinessFacade } from '../../shared-new/store/repo-business/repo-business.facade';
import { PositionEditComponent } from '../position-edit/position-edit.component';

@Component({
  selector: 'app-positions-popup',
  templateUrl: './positions-popup.component.html',
  styleUrls: ['./positions-popup.component.scss'],
})
export class PositionsPopupComponent extends BaseUnsubscribeComponent implements OnInit {
  @Input() public position: RepoPosition;
  @ViewChild('positionEdit') positionEdit: PositionEditComponent;

  constructor(
    public readonly modal: NgbActiveModal,
  ) {
    super();
  }

  public positionSaved(position: RepoPosition): void {
    this.modal.close(JSON.stringify(position));
  }

  public dismissPopup(): void {
    this.modal.dismiss(JSON.stringify(this.position));
  }
   

  public ngOnInit(): void {
   
  }

  public savePosition() {
    this.positionEdit?.submitForm();
  }
  
}
